import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class FormEndpoint extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'FormEndpoint',
    refs: ['btn', 'form', 'success', 'error', 'file', 'fileLabel'],
    options: {
      endpoint: String,
    },
  };

  /**
   * Submit form
   * @param {*} param0
   */
  onFormSubmit({ event }) {
    event.preventDefault();
    this.fetchEndpoint();
  }

  /**
   * Set file name when file input changing
   */
  onFileChange() {
    if (this.$refs.file.files.length > 0) {
      this.$refs.fileLabel.textContent = this.$refs.file.files[0].name;
    }
  }

  /**
   *
   */
  onBtnClick() {
    this.$refs.form.classList.toggle('hidden');
  }

  /**
   * Fetch middleware endpoint
   * @returns {void}
   */
  fetchEndpoint() {
    fetch(this.$options.endpoint, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: new FormData(this.$refs.form),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          if (this.$refs.btn) {
            this.$refs.btn.classList.add('hidden');
          }
          this.$refs.success.classList.remove('hidden');
          this.$refs.form.classList.add('hidden');
        } else {
          this.$refs.error.classList.remove('hidden');
        }
      })
      .catch(() => {
        this.$refs.error.classList.remove('hidden');
      });
  }
}
